import React from 'react';
import {
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  makeStyles,
} from '@material-ui/core';

import p from 'theme/palette';

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: 'var(--sl-bg-surface)',
    color: p.defaultText,
  },
  title: {
    color: p.defaultText,
    fontSize: 18,
    fontWeight: 600,
    fontFamily: 'Montserrat, sans-serif',
    letterSpacing: '-0.01em',
  },
  content: {
    padding: 0,
    fontSize: 16,
    color: p.defaultText,
  },
  divider: {
    backgroundColor: p.cardTitleBorder,
  },
  closeButton: {
    position: 'absolute',
    width: 40,
    height: 40,
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: p.grey400,
  },
  backdrop: {
    backgroundColor: 'rgba(8, 14, 24, 0.7)',
    backdropFilter: 'blur(4px)',
  },
}));

const BasicDialog = ({ open, onClose, actions, title, children, ...rest }) => {
  const classes = useStyles();
  return (
    <Dialog
      onClose={onClose}
      open={open}
      aria-labelledby="dialog-title"
      fullWidth
      maxWidth="sm"
      PaperProps={{ className: classes.paper }}
      BackdropProps={{ className: classes.backdrop }}
      {...rest}
    >
      <DialogTitle id="dialog-title" disableTypography>
        <Typography className={classes.title}>{title}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <i className="material-symbols-outlined" style={{ fontSize: 20 }}>close</i>
          </IconButton>
        ) : null}
      </DialogTitle>
      <Divider className={classes.divider} />
      <DialogContent className={classes.content}>{children}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default BasicDialog;
